import React from 'react';
import Layout from '../components/Layout';

const PageLayout: React.FC<{ location: Location }> = ({ children, location }) => {
  return <Layout location={location}>{children}</Layout>;
};

export const BrowserPageLayout = PageLayout;
export const SsrPageLayout = PageLayout;
